module.exports = __webpack_public_path__ + "static/media/sxn.1629e09d.jpg";